import { MenuItem } from "./menu.model";

export const MENU_ADMIN: MenuItem[] = [
  { id: 1, label: "Menú", isTitle: true },
  { id: 2, label: "Panel Principal", icon: "bx bx-home-circle", link: "/panel-principal" },

  { id: 10, label: "Ventas", isTitle: true },
  { id: 11, label: "Clientes",     icon: "bx bx-buildings", link: "/clientes" },
  { id: 12, label: "Productos",    icon: "bx bx-package",   link: "/productos" },
  { id: 13, label: "Cotizaciones", icon: "bx bx-receipt",   link: "/cotizaciones" },
  { id: 14, label: "Órdenes",      icon: "bx bx-cart-alt",  link: "/ordenes" },
  { id: 15, label: "Facturas",     icon: "bx bx-file",      link: "/facturas" },

  { id: 20, label: "Operaciones", isTitle: true },
  { id: 21, label: "Inventario",      icon: "bx bx-archive-in",     link: "/inventario" },
  { id: 22, label: "Caja",            icon: "bx bx-wallet",         link: "/caja" },
  { id: 23, label: "Tasas de cambio", icon: "bx bx-dollar-circle",  link: "/tasas-cambio" },

  { id: 30, label: "Contenido", isTitle: true },
  { id: 31, label: "Blog / Noticias", icon: "bx bx-news", link: "/noticias" },

  { id: 40, label: "Administración", isTitle: true },
  { id: 41, label: "Usuarios",  icon: "bx bx-user-circle", link: "/usuarios" },
  { id: 42, label: "Mi Perfil", icon: "bx bx-id-card",     link: "/mi-perfil" },
];

export const MENU_CLIENTE: MenuItem[] = [
  { id: 1, label: "Cliente", isTitle: true },

  { id: 2, label: "Inicio",          icon: "bx bx-home",         link: "/c/inicio"        },
  { id: 3, label: "Catálogo",        icon: "bx bx-store",        link: "/c/catalogo"      },
  { id: 4, label: "Carrito",         icon: "bx bx-cart",         link: "/c/carrito"       },
  { id: 5, label: "Mis pedidos",     icon: "bx bx-receipt",      link: "/c/cotizaciones"  },
  { id: 6, label: "Mis órdenes",     icon: "bx bx-book-content", link: "/c/ordenes"       },
  { id: 7, label: "Noticias",        icon: "bx bx-news",         link: "/c/noticias"      },
  { id: 8, label: "Mi Perfil",       icon: "bx bx-user",         link: "/c/perfil"        },
];
